import script from "./Summary.vue?vue&type=script&setup=true&lang=js"
export * from "./Summary.vue?vue&type=script&setup=true&lang=js"

import "./Summary.vue?vue&type=style&index=0&id=0d8aefcb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.9_vue@3.5.9_webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d8aefcb"]])

export default __exports__